var _a;
import { Insurance_Plan_Referral_Type, } from 'generated/types';
import { enumValuesFactory } from 'utils/objectHelper';
var enumDescriptionMap = (_a = {},
    _a[Insurance_Plan_Referral_Type.None] = 'Does Not Require',
    _a[Insurance_Plan_Referral_Type.Specialist] = 'Plan Requires Referral For Specialist',
    _a);
export var InsurancePlanReferralTypeEnum = {
    name: 'InsuranceType',
    enumValues: enumValuesFactory(enumDescriptionMap)
};
